import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz'

export const formatDate = ({ dateTime, timeZone = 'America/Sao_Paulo', formaT = 'dd/MM/yyyy' }) => {
  if (!dateTime) return ''
  const date = utcToZonedTime(dateTime, timeZone);
  return format(date, formaT);
}
export const formatDateDMY = (dateTime, timeZone = 'America/Sao_Paulo', formaT = 'dd/MM/yyyy') => {
  if (!dateTime) return ''
  const date = utcToZonedTime(dateTime, timeZone);
  return format(date, formaT);
}
/**
 * Ex.: 04/05/2026 às 16:32 (ISO ou string aceita por formatDateDMY)
 */
export function formatDateAtTimeBR(dateTime, timeZone = 'America/Sao_Paulo') {
  if (!dateTime) return ''
  return formatDateDMY(dateTime, timeZone, "dd/MM/yyyy 'às' HH:mm")
}

export function formatDateTimeDMY(dateTime, timeZone = 'America/Sao_Paulo') {
  if (!dateTime) return ''

  if (dateTime.indexOf('T') != -1) {
    return formatDateDMY(dateTime, timeZone, 'dd/MM/yyyy HH:mm:ss')
  } else {
    // FORMATA A DATA
    /*
    import { parseISO } from 'date-fns';
    import { zonedTimeToUtc } from 'date-fns-tz';

    const parsedDate = parseISO('2018-04-01 16:00:00');
    const znDate = zonedTimeToUtc(parsedDate, 'America/Sao_Paulo');
    */
    let d = dateTime.split(' ')
    let dateT = d[0]
    dateT = dateT.split('-')
    dateT = dateT[2] + '/' + dateT[1] + '/' + dateT[0]
    // retorna data e hora
    return dateT + ' ' + d[1].substring(0, 8);
  }

}

export function getDiffBetween(start, end) {
  if (!start) return ''
  if (!end) return ''

  if (start.indexOf('T') != -1) {
    const timeInBrisbane = utcToZonedTime(start, 'America/Sao_Paulo')
    start = format(timeInBrisbane, 'yyyy-MM-dd HH:mm:ss')
  }
  if (end.indexOf('T') != -1) {
    const timeInBrisbane = utcToZonedTime(end, 'America/Sao_Paulo')
    end = format(timeInBrisbane, 'yyyy-MM-dd HH:mm:ss')
  }
  const today = new Date(start)
  const endDate = new Date(end)

  const days = parseInt((endDate - today) / (1000 * 60 * 60 * 24));
  const hours = parseInt(Math.abs(endDate - today) / (1000 * 60 * 60) % 24);
  const minutes = parseInt(Math.abs(endDate.getTime() - today.getTime()) / (1000 * 60) % 60);
  const seconds = parseInt(Math.abs(endDate.getTime() - today.getTime()) / (1000) % 60);
  let date = ''

  if (days) {
    date = days + ' dias '
  } else if (hours || minutes) {
    date += hours ? hours + 'h' : ''
    date += minutes ? minutes + 'min  ' : ''
  } else {
    date += seconds ? seconds + 's ' : ''
  }

  return date
}

export function getDiffTimeBetweenCurrentDate(dateString = '', now = new Date()) {
  const dayInMilliseconds = 86400000
  if ([null, undefined, false, true].includes(dateString)) {
    return dateString
  }
  const date = new Date(dateString)
  const isInvalidDate = isNaN(date.getTime())

  if (isInvalidDate) {
    return dateString
  }

  const month = date.getMonth()
  const day = date.getDate()
  const hour = date.getHours()
  const minutes = date.getMinutes()
  const seconds = date.getSeconds()

  const buildMessage = (label, value) => {
    if (value !== 1) {
      return `${value} ${label}s atrás`
    }

    return `${value} ${label} atrás`
  }
  const notZero = value => value !== 0

  if (month !== now.getMonth()) {
    const diff = Math.abs(now - date)
    const days = Math.ceil(diff / dayInMilliseconds)

    return buildMessage('dia', days)
  }

  if (day < now.getDate() && notZero(day)) { return buildMessage('dia', now.getDate() - day) }
  if (hour < now.getHours() && notZero(hour)) { return buildMessage('hora', now.getHours() - hour) }
  if (minutes < now.getMinutes() && notZero(minutes)) { return buildMessage('minuto', now.getMinutes() - minutes) }
  if (seconds < now.getSeconds() && notZero(seconds)) { return buildMessage('segundo', now.getSeconds() - seconds) }

  return buildMessage('segundo', 1)
}

export function getFormatTimestamp(timestamp, lang, options) {
  let dateObj = new Date(timestamp)

  if (!options) {
    options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }
  }

  return dateObj.toLocaleString(lang, options)
}
export const addDays = (days, timeZone = 'America/Sao_Paulo') => {
  var date = new Date()
  date.setDate(date.getDate() + days)
  return formatDateDMY(date, timeZone)
}

export const formatDateInTimestamp = { year: 'numeric', month: '2-digit', day: '2-digit' }
export const formatTimeInTimestamp = { ...formatDateInTimestamp, hour: '2-digit', minute: '2-digit', second: '2-digit' }

export function validateDateStartEnd({ datestart, dateend }) {
  const start = new Date(datestart)
  const end = new Date(dateend)
  if (start > end) {
    return false
  } else {
    return true
  }
}

export function isDateMonth() {
  const date = new Date()
  const currentYear = date.getFullYear();
  const currentMonth = date.getMonth() + 1;
  const days = getDaysMonth(currentMonth, currentYear)
  return days.map(item => `${currentYear}-${addZero(currentMonth)}-${addZero(item)}`)
}

export function getDaysMonth(month, year) {
  month--;

  var date = new Date(year, month, 1);
  var days = [];
  while (date.getMonth() === month) {
    days.push(date.getDate());
    date.setDate(date.getDate() + 1);
  }
  return days;
}

export function addZero(item) {
  return item < 10 ? '0' + item : item
}

export const defaultOperating = [
  { day: 0, hours: [{ start: null, end: null }] },
  { day: 1, hours: [{ start: null, end: null }] },
  { day: 2, hours: [{ start: null, end: null }] },
  { day: 3, hours: [{ start: null, end: null }] },
  { day: 4, hours: [{ start: null, end: null }] },
  { day: 5, hours: [{ start: null, end: null }] },
  { day: 6, hours: [{ start: null, end: null }] },
  { day: 99, hours: [{ start: null, end: null }] },
]
export const formatDateTimePicker = (date) => {
  let day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
  let month = date.getMonth() + 1 > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
  let year = date.getFullYear()
  let hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours();
  let min = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes();

  return `${day}/${month}/${year} ${hours}:${min}`;
}

export function formatCRMDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  const now = new Date();

  // Set to midnight for day comparison
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const targetDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

  const diffTime = targetDate - today;
  const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 0) {
    // Hoje: exibe apenas a hora caso seja hoje
    return 'Hoje';
  } else if (diffDays === 1) {
    return 'Amanhã';
  } else if (diffDays === -1) {
    return 'Ontem';
  } else {
    // Outro dia fora desse range: mostrar só o dia e o mês, não precisa exibir o ano
    return date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
  }
}
